import React from 'react';

export default function SearchBar({
  searchQuery,
  setSearchQuery,
  handleSearch,
  handleClear,
  totalCount,
  displayCount
}) {
  return (
    <div className="d-flex align-items-center flex-grow-1 me-4">
      <input
        type="text"
        className="form-control me-2"
        placeholder="Search applicants..."
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        onKeyPress={(e) => e.key === 'Enter' && handleSearch()}
      />
      <button className="btn btn-primary me-2" onClick={handleSearch}>Search</button>
      <button className="btn btn-secondary me-3" onClick={handleClear}>Clear</button>
      
      <span className="text-muted flex-shrink-0">
        Displaying {displayCount} out of {totalCount} applicants
      </span>
    </div>
  );
} 